import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: boolean = false;

const isLoadingSlice = createSlice({
  initialState,
  name: "isLoading",
  reducers: {
    setIsLoading: (state: boolean, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setIsLoading } = isLoadingSlice.actions;

export default isLoadingSlice.reducer;
